import { render } from "./ShallowReactiveShallowRef.vue?vue&type=template&id=1ca7f3af"
import script from "./ShallowReactiveShallowRef.vue?vue&type=script&lang=ts"
export * from "./ShallowReactiveShallowRef.vue?vue&type=script&lang=ts"
script.render = render

export default script